import React, { Component } from 'react';
import classNames from 'classnames';
import './TimeSlot.scss';
import { TIME_SLOTS, WORK_DAYS, ALBASTAR_TIME_SLOTS, PANATCH_WORK_DAYS, PANATCH_TIME_SLOTS  } from '../../common/constants';
import Icon from '../Icon';
import Input from '../Input';
import { toast } from 'react-toastify';

// import variables from '../../styles/includes/variables.scss';
class TimeSlot extends Component {
  state = {
    tab: 'Monday',
    selection: this.props.fromScheduling ? this.props.fromScheduling.length > 0 ? this.selectedSlots(this.props.fromScheduling) : [] : [],
    filterTab:null,
    filterDay:[],
    otherValue:null,
    otherSelected:false,
  };


  selectedSlots(data){
    let slots = []
    data.forEach(item => item.slots.forEach(value => {
      slots.push(item.day+' '+value)
    }))
    return slots

  }
  handleSelection(slot) {
    this.setState({otherSelected:false,otherValue:''})
    const { selection, tab, otherValue } = this.state;
    const { handleSelectionFormData } = this.props;
    let selections = []
    let tempSelections = [];
    tempSelections = selection.filter( s => s.includes(`${tab} Other: `) );
    if(tempSelections.length>0){
      let temprorySelection = [];
      let localSelections = [];
      localSelections = selection.map((slot)=>{
        if(slot.includes(`${tab} Other: `)){
          return null
        }else{
          return slot
        }})
        temprorySelection = localSelections.filter( s => s!== null );
        if(temprorySelection.includes(slot)){
          selections = temprorySelection.filter( s => s!== slot )
      }else{
          selections = [...temprorySelection, slot];
      }
        this.setState({ selection: selections })
        handleSelectionFormData(selections.join(","));
    }else{
      if(selection.includes(slot)){
        selections = selection.filter( s => s!== slot )
    }else{
        selections = [...selection, slot];
    }
      this.setState({ selection: selections })
      handleSelectionFormData(selections.join(",")); 
    }
  }
  handleOther(tab){
    this.setState({otherSelected:true,otherValue:null});
    const { selection } = this.state;
    const { handleSelectionFormData } = this.props;
    let tempSelections = [];
    let selections = [];
    tempSelections = selection.map((slot)=>{
      if(slot.includes(tab)){
        return null
      }else{
        return slot
      }
    })
    selections = tempSelections.filter( s => s!== null )
     this.setState({ selection: selections })
     handleSelectionFormData(selections.join(","));
  }
  handleOtherInput({tab,otherValue}){
      const { selection }=this.state;
      const { handleSelectionFormData } = this.props;
      let day = tab;
      let selections = [];
      let tempSelections = [];
      tempSelections = selection.filter( s => s.includes(`${tab} Other: `) );
      if(tempSelections.length>0){
        let temprorySelection = [];
        let localSelections = [];
        localSelections = selection.map((slot)=>{
          if(slot.includes(`${tab} Other: `)){
            return null
          }else{
            return slot
          }})
          temprorySelection = localSelections.filter( s => s!== null );
          temprorySelection = [...temprorySelection, `${tab} Other: ${otherValue}`];
          handleSelectionFormData(temprorySelection.join(","));
          this.setState({otherSelected:true,tab: day, selection: temprorySelection, otherValue:otherValue});
      }else{
        selections = [...selection, `${tab} Other: ${otherValue}`];
        handleSelectionFormData(selections.join(","));
        this.setState({otherSelected:true,tab: day, selection: selections, otherValue:otherValue});
      }  
  }
  handleDay(day){
    const {otherSelected, selection, otherValue, tab}=this.state;
    const { handleSelectionFormData } = this.props;

    let tempSelections = [];
    tempSelections = selection.filter( s => s.includes(`${day} Other: `) );
    if(tempSelections.length>0){

      let tempText = tempSelections[0];
      let otherValue = tempText.replace(`${day} Other: `,'')
      setTimeout(()=>{
        this.setState({otherSelected:true,otherValue:otherValue})
      },500)
      
    }
  
    let selections = [];
    if(otherSelected && (otherValue === '' || otherValue === null)){
      toast.error(` 🚫 Other field is required.`, { autoClose: 12000, position: 'top-center' })
    }else if(otherSelected && (otherValue !== '' || otherValue !== null)){
      let tempSelections = [];
      tempSelections = selection.filter( s => s.includes(`${tab} Other: `) );
      if(tempSelections.length>0){
        let temprorySelection = [];
        let localSelections = [];
        localSelections = selection.map((slot)=>{
          if(slot.includes(`${tab} Other: `)){
            return null
          }else{
            return slot
          }})
          temprorySelection = localSelections.filter( s => s!== null );
          temprorySelection = [...temprorySelection, `${tab} Other: ${otherValue}`];
          handleSelectionFormData(temprorySelection.join(","));
          this.setState({otherSelected:false,tab: day, selection: temprorySelection, otherValue:null});
      }else{
        selections = [...selection, `${tab} Other: ${otherValue}`];
        handleSelectionFormData(selections.join(","));
        this.setState({otherSelected:false,tab: day, selection: selections, otherValue:null});
      }
    }else{
      this.setState({tab: day})
    }
  
  }

  componentDidMount(){
    let theme = localStorage.getItem('theme');
    if(this.props.fromScheduling && this.props.fromScheduling.length > 0){
      this.props.handleSelectionFormData(this.state.selection.join(","));
    }
       // Modified by: Tarkeshwar Prasad Yadav
      // Modified on: 08/09/2022
      // Jira ticket: JUN-3104
      // Comment: Preferred Appointment Times will be shown as per homeowner availability.
if(this.props.from === 'srscheduling' && theme!== 'Rize' && theme!== 'Formwerks'){
  let workDays = theme === "Panatch" ? PANATCH_WORK_DAYS : WORK_DAYS
  const { filterDay }=this.state
  this.setState({filterTab:this.props.fromScheduling[0].day})
  workDays.map((dayItem,index)=>{
    this.props.fromScheduling.map((preferedDayItem)=>{
      if(dayItem === preferedDayItem.day)
      {
        let dayData= filterDay.filter((tn) => tn === preferedDayItem.day);
        if(dayData.length>0)
        {}else{
          filterDay.push(preferedDayItem.day)
        }
      }
       })
  })
 }
  }

  render() {
    const { tab, selection,filterTab } = this.state;
    let theme = localStorage.getItem('theme');
    let slots = theme === "Albaster" ? ALBASTAR_TIME_SLOTS : theme === "Panatch"?PANATCH_TIME_SLOTS: TIME_SLOTS  //  let days = this.props.fromScheduling ? this.props.fromScheduling.length > 0 ? new Set( this.props.fromScheduling.map(item => item.day)) : WORK_DAYS : WORK_DAYS
    let days = theme === "Panatch" ?PANATCH_WORK_DAYS:WORK_DAYS  //  let disableForSchedule = this.props.fromScheduling ? this.props.fromScheduling.length > 0 ? true : false : false
    let disableForSchedule = false
    return (
      <div className="timeSlot">
        <div  className="timeSlot__require">
        <div className="timeSlot__label">Homeowner Availability</div>
        <div className="timeSlot__required" />
      </div>
      {
        this.props.serviceRequestForm?(<div>Please indicate what days and times might work for you.</div>):(null)
      }
      <br/>
        <div className="timeSlot__control">

{
  this.props.from === 'srscheduling'?
  (
  theme!== 'Rize' && theme!== 'Formwerks'?
  (<>
    
    <div className="timeSlot__tabs">
            {this.state.filterDay.map(day => (
              <button
                type="button"
                key={day}
                onClick={() => this.setState({ filterTab: day })}
                className={
                  classNames(
                    'timeSlot__tab',
                    {
                      'timeSlot__tab--active': day === filterTab,
                    }
                  )
                }
              >
                {day}
              </button>
            ))}
          </div>
          <div className="timeSlot__days">
            {
            this.state.selection.map((selected)=>(
             selected.includes(filterTab)?(
              <button
              type="button"
              //key={tab + ' ' + slot}
              //onClick={() => disableForSchedule ?  {} : this.handleSelection(tab + ' ' + slot)}
              className={
                classNames(
                  'timeSlot__slot',
                  {
                    'timeSlot__slot--active': selection.indexOf(selected) > -1,
                  }
                )     
              }
            >
              <div className="timeSlot__bullet">
                <Icon
                  glyph="check"
                  weight="regular"
                />
              </div>
              {selected.replace(filterTab,'')}
            </button>
             ):(null)
            ))
          }
          </div>
  </>):(null)
  )
  :
  (
    <>

    <div className="timeSlot__tabs">
            {days.map(day => (
              <button
                type="button"
                key={day}
                onClick={() => this.handleDay(day)}
                className={
                  classNames(
                    'timeSlot__tab',
                    {
                      'timeSlot__tab--active': day === tab,
                    }
                  )
                }
              >
                {day}
              </button>
            ))}
          </div>
          <div className="timeSlot__days">
            {slots.map(slot => (
              <button
                type="button"
                key={tab + ' ' + slot}
                onClick={() => slot === "Other:"?this.handleOther(tab):disableForSchedule ?  {} : this.handleSelection(tab + ' ' + slot)}
                className={
                  classNames(
                    'timeSlot__slot',
                    {
                      'timeSlot__slot--active':slot === "Other:"?this.state.otherSelected: selection.indexOf(tab + ' ' + slot) > -1,
                    }
                  )
                }
                style={slot === "Other:"?{backgroundColor:'White'}:{}}
              >
                <div className="timeSlot__bullet">
                  <Icon
                    glyph="check"
                    weight="regular"
                  />
                </div>
                {slot}
                {slot === "Other:" && 
                (
                  <>
                  &nbsp;&nbsp; <Input
                  style={{marginTop:'30px'}}
                  value={this.state.otherValue}
                  onChange={(e) => {this.setState({otherValue:e.target.value});
                  this.handleOtherInput({tab,otherValue:e.target.value});
                }}
                  //errors={'this.state.errors.password'}
                />
                </>
                )
                }
              </button>
            ))}
          </div>
          
    </>
  )
}

        </div>
      </div>
    );
  }
}

export default TimeSlot;
